import React from "react";
import { Box } from "rebass";
import { Card, TextField, TextContainer, TextStyle } from "@shopify/polaris";
import Toggle from "components/core/formik/Toggle";
import { useFormikContext } from "formik";
import SubscriptionGateway from "components/auth/SubscriptionGateway";

export default function ExpirationDatePolicy() {
  const { values, setFieldValue } = useFormikContext();
  return (
    <SubscriptionGateway
      permission="policies.id_expiration_date"
      minimumPlan="Business"
    >
      <Card.Section title="Expired IDs Policy">
        <TextContainer spacing="tight">
          <TextStyle variation="subdued">
            {values?.idCheckPolicy?.expirePolicy?.enabled
              ? "Accept IDs that have expired within a grace period."
              : "Expired IDs will not be accepted."}
          </TextStyle>
        </TextContainer>
        <Box my={3}>
          <Toggle
            field="idCheckPolicy.expirePolicy.enabled"
            label={<>Allow expired IDs</>}
          />
          {values?.idCheckPolicy?.expirePolicy?.enabled && (
            <Box mt={3} width={300}>
              <TextField
                label="Accept IDs that have expired within"
                type="number"
                min={0}
                value={
                  values?.idCheckPolicy?.expirePolicy?.lag?.days?.toString() ||
                  "0"
                }
                onChange={(val) =>
                  setFieldValue(
                    "idCheckPolicy.expirePolicy.lag.days",
                    val === "" ? 0 : parseInt(val, 10)
                  )
                }
                suffix={<TextStyle variation="subdued">days</TextStyle>}
                helpText={
                  values?.idCheckPolicy?.expirePolicy?.lag?.days <= 0
                    ? "Expired IDs will not be accepted"
                    : `IDs that have expired within ${values?.idCheckPolicy?.expirePolicy?.lag?.days} days will be accepted.`
                }
              />
            </Box>
          )}
        </Box>
      </Card.Section>
    </SubscriptionGateway>
  );
}
